<template>
  <!--  联系我们-->
  <div class="moreOptionsContainer" v-if="linkUsStatus && screenType === 'pc'">
    <div class="moreOptionsBox">
      <el-image :src="maskTelIcon" class="maskTelIcon"></el-image>
      <div
        class="title SourceHanSansCN-Medium"
        v-html="'您可以通过以下方式联系我们<br/>获取更多资讯。'"
      ></div>
      <div class="contactInformationBox">
        <div class="bBox" v-if="isParentShow">
          <el-image
            :src="official_account_icon"
            class="official_account_icon"
            fit="contain"
          ></el-image>

          <div
            class="bTip SourceHanSansCN-Regular"
            v-html="'斯泰兰蒂斯汽车<br/>金融公众号'"
          ></div>
        </div>
        <div class="brandBox" v-if="isShow">
          <el-image
            :src="qrCodeBox[financialIndex].img"
            class="code_icon"
            fit="contain"
          ></el-image>
          <!--<div class="brandTitle SourceHanSansCN-Regular"-->
          <!--     v-html="qrCodeBox[financialIndex].name + '汽车官方二维码'"></div>-->
          <div
            class="brandTitle SourceHanSansCN-Regular"
            v-if="financialIndex < 6"
            v-html="'微信扫一扫<br/>使用小程序'"
          ></div>
          <div
            class="brandTitle SourceHanSansCN-Regular"
            v-else
            v-html="'扫码联系金融顾问'"
          ></div>
        </div>
        <div class="brandBox" v-else>
          <el-image :src="onlineIcon" class="code_icon"></el-image>
          <div
            class="brandTitle SourceHanSansCN-Regular"
            v-html="'扫码开启线上申请'"
          ></div>
        </div>

        <!--<div class="consultationInformationBox">-->
        <!--  <div class="cInfo1 SourceHanSansCN-medium">欢迎联系咨询:</div>-->
        <!--  <div class="cInfoTel EncodeSansExpanded-Regular">Tel: 400-921-3155</div>-->
        <!--  <div class="cInfoEmail EncodeSansExpanded-Regular">Email: FCAAFC.CS@stellantisafc.com.cn</div>-->
        <!--</div>-->
      </div>

      <el-image
        :src="close_icon"
        class="close_icon"
        @click="handleCloseLinkUs"
      ></el-image>
    </div>
  </div>

  <div class="moreOptionsContainer" v-if="linkUsStatus && screenType === 'mobile'">
    <div class="linkBox">
      <div
        class="title SourceHanSansCN-Medium"
        v-html="'您可以通过以下方式联系我们<br/>获取更多资讯。'"
      ></div>
      <el-image :src="mBg" class="mBg"></el-image>
      <div class="qcodeBox">
        <div class="bBox" v-if="isParentShow">
          <el-image
            :src="m_official_account_icon"
            class="official_account_icon"
            fit="contain"
          ></el-image>

          <div
            class="bTip SourceHanSansCN-Regular"
            v-html="'斯泰兰蒂斯汽车<br/>金融公众号'"
          ></div>
        </div>

        <div class="brandBox" v-if="isShow">
          <el-image
            :src="qrCodeBox[financialIndex].img"
            class="code_icon"
            fit="contain"
          ></el-image>
          <div
            class="brandTitle SourceHanSansCN-Regular"
            v-if="financialIndex < 6"
            v-html="'微信扫一扫<br/>使用小程序'"
          ></div>
          <div
            class="brandTitle SourceHanSansCN-Regular"
            v-else
            v-html="'扫码联系金融顾问'"
          ></div>
        </div>
        <div class="brandBox" v-else>
          <el-image :src="onlineIcon" class="code_icon"></el-image>
          <div
            class="brandTitle SourceHanSansCN-Regular"
            v-html="'扫码开启线上申请'"
          ></div>
        </div>
      </div>

      <el-image
        :src="close_icon"
        class="close_icon"
        @click="handleCloseLinkUs"
      ></el-image>
    </div>
  </div>
</template>

<script setup>
// import maskTelIcon from "@/assets/components/onlineApplication/maskTelIcon.png";
// import mBg from "@/assets/components/onlineApplication/mBg.png";

const maskTelIcon =
  imgCDN + "assets/components/onlineApplication/maskTelIcon.png?v=" + imgVersion;
const mBg = imgCDN + "assets/components/onlineApplication/mBg.png?v=" + imgVersion;

import official_account_icon from "@/assets/financialService/financialCalculation/official_account.png";
import m_official_account_icon from "@/assets/financialService/financialCalculation/mOfficial_account.png";

import close_icon from "@/assets/components/onlineApplication/close_icon.png";
import { defineExpose, onMounted, ref } from "vue";
import { AdaptationScreen, imgCDN, imgVersion } from "@/common/js/config.default";

import { getBrandList } from "@/http/financialService/financialCalculation";

const linkUsStatus = ref(false);
const isShow = ref(true);
const isParentShow = ref(true);
const financialIndex = ref(0);
const qrCodeBox = ref([
  {
    img: "",
    name: "玛莎拉蒂",
    remark: "0",
  },
  {
    img: "",
    name: "阿尔法罗密欧",
    remark: "1",
  },
  {
    img: "",
    name: "标致",
    remark: "2",
  },
  {
    img: "",
    name: "Jeep",
    remark: "3",
  },
  {
    img: "",
    name: "依维柯",
    remark: "4",
  },
  {
    img: "",
    name: "DS",
  },
  {
    img: "",
    name: "迈凯伦",
    remark: "6",
  },
  {
    img: "",
    name: "法拉利",
    remark: "7",
  },
]);
const onlineIcon =
  imgCDN + "assets/components/onlineApplication/online.jpg?v=" + imgVersion;
const screenType = ref("pc");

const openMask = (index, show = true, parentShow = true) => {
  linkUsStatus.value = true;
  isShow.value = show;
  isParentShow.value = parentShow;
  financialIndex.value = Number(index);
  getBrandListFn();
};

const handleCloseLinkUs = () => {
  linkUsStatus.value = false;
};

const getBrandListFn = () => {
  getBrandList({}).then((res) => {
    if (res.code === 200) {
      qrCodeBox.value.forEach((item) => {
        res.data.forEach((cItem) => {
          if (item.remark == cItem.remark) {
            item.img = "https://afc.oss-cn-shanghai.aliyuncs.com" + cItem.qrcode;
          }
        });
      });

      console.log(qrCodeBox.value, "==qrCodeBox==");
    }
  });
};

onMounted(() => {
  AdaptationScreen(
    () => {
      //console.log("手机")
      screenType.value = "mobile";
    },
    () => {
      //console.log("PC")
      screenType.value = "pc";
    }
  );
});

defineExpose({
  openMask,
  handleCloseLinkUs,
});
</script>

<style scoped lang="scss">
@import "@/common/scss/breakpoints";

.moreOptionsContainer {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99000;

  .moreOptionsBox {
    width: 900px;
    height: 530px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .maskTelIcon {
      width: 276px;
      height: 447px;
      margin-left: 108px;
      margin-top: 82px;
    }

    .title {
      width: auto;
      height: auto;
      font-size: 20px;
      color: #19559d;
      position: absolute;
      top: 160px;
      right: 170px;
      line-height: normal;
      //margin: 96px auto 0;
    }

    .contactInformationBox {
      width: 310px;
      height: auto;
      //margin: 70px auto 0;
      display: flex;
      position: absolute;
      top: 254px;
      right: 120px;

      .bBox {
        width: 143px;
        height: auto;
        margin-right: 30px;
        display: flex;
        flex-direction: column;

        .official_account_icon {
          width: 143px;
          height: 143px;
        }

        .bTip {
          width: 100%;
          height: auto;
          font-size: 15px;
          color: #a8a8a8;
          text-align: center;
          margin-top: 10px;
          line-height: normal;
        }
      }

      .brandBox {
        width: 143px;
        height: auto;
        display: flex;
        flex-direction: column;
        //overflow: hidden;
        .code_icon {
          width: 143px;
          height: 143px;
          transform: scale(1.08);
          //margin-top: 3px;
        }

        .brandTitle {
          width: 100%;
          height: auto;
          font-size: 15px;
          color: #a8a8a8;
          text-align: center;
          margin-top: 15px;
          line-height: normal;
        }
      }

      .consultationInformationBox {
        width: auto;
        height: 141px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .cInfo1 {
          font-size: 20px;
          color: #19559d;
          margin-left: 50px;
          margin-top: 20px;
        }

        .cInfoTel {
          font-size: 20px;
          color: #999999;
          margin-left: 50px;
          margin-top: 22px;
        }

        .cInfoEmail {
          font-size: 20px;
          color: #999999;
          margin-left: 50px;
          //margin-top: 8px;
        }
      }
    }

    .close_icon {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 28px;
      right: 28px;
      cursor: pointer;
    }
  }
}

@include media-breakpoint-up("md") {
  @import "./index-md.scss";
}
</style>
